import { Injectable }    from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import {Observable} from 'rxjs/Rx';

import { Provincia } from './provincia';

import myGlobals = require('../config');

@Injectable()
export class ProvinciaService {

  private provinciaUrl = myGlobals.default.BASE_URL+'/provincia/';  // URL to web api

  constructor(private http: Http) { }

  //Obtener todas las provincias
  getProvincias() {
    return this.http.get(this.provinciaUrl)
               .map((response) => response.json());
  }

  //Obtener una provincias
  getProvincia(_id: string): Observable<Provincia>  {
    return this.http.get(this.provinciaUrl+_id)
               .map((response) => response.json());
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/provincia/provincia.service.ts